import { AlertTriangle } from "lucide-react";
import { THEME } from "@/config/theme";

interface Props {
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({ title, message, confirmLabel = "Delete", onConfirm, onCancel }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={onCancel}>
      <div
        className={`${THEME.panel.bg} ${THEME.panel.border} rounded-xl shadow-2xl p-5 w-80 flex flex-col gap-4`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 text-red-400">
          <AlertTriangle size={18} />
          <span className="text-[15px] font-semibold">{title}</span>
        </div>
        <p className="text-[14px] text-canvas-muted leading-snug">{message}</p>
        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            className={`px-3 py-1.5 text-[13px] rounded-lg ${THEME.panel.muted} ${THEME.panel.hoverText} ${THEME.panel.hover} transition-colors`}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-3 py-1.5 text-[13px] rounded-lg bg-red-600 hover:bg-red-500 text-white font-medium transition-colors"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
